/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import { TroyWebTracker } from "utils/tracking"
import { AppState } from "store/store.type"
import { EventAction, EventCategory } from "constants/tracking"
import { BULK_UPLOAD_TYPE, BulkUploadContext } from "../BulkUploadContext"

export const useScribeBulkUploadActions = () => {
  const {
    merchantGroupID,
    merchantID,
    outletV2,
    menuGroupDetail,
  } = useSelector((state: AppState) => state.menu)

  const { bulkUploadType } = useContext(BulkUploadContext)

  return useMemo(() => {
    const category =
      bulkUploadType === BULK_UPLOAD_TYPE.INVENTORY
        ? EventCategory.inventoryBulkupdatesTab
        : EventCategory.menuBulkupdatesTab

    const getBusinessType = () => {
      if (menuGroupDetail?.menuGroupID) {
        return menuGroupDetail.businessType ?? 0
      }
      return outletV2?.businessType ?? 0
    }

    const labels = {
      MERCHANT_GROUP_ID: merchantGroupID,
      STORE_ID: merchantID,
      BUSINESS_TYPE: getBusinessType(),
      MENU_GROUP_ID: menuGroupDetail?.menuGroupID,
    }

    return {
      trackBulkUploadPageView: () => {
        TroyWebTracker.sendEvent({
          category,
          action: EventAction.pageView,
          labels: {
            ...labels,
            TIMESTAMP: new Date().valueOf(),
          },
        })
      },
      trackEditInventoryClick: () => {
        TroyWebTracker.sendEvent({
          category,
          action: EventAction.clickEditinventory,
          labels: {
            ...labels,
            TIMESTAMP: new Date().valueOf(),
          },
        })
      },
      trackCreateItemsClick: () => {
        TroyWebTracker.sendEvent({
          category,
          action: EventAction.clickCreateItems,
          labels: {
            ...labels,
            TIMESTAMP: new Date().valueOf(),
          },
        })
      },
      trackEditItemsClick: () => {
        TroyWebTracker.sendEvent({
          category,
          action: EventAction.clickEditItems,
          labels: {
            ...labels,
            TIMESTAMP: new Date().valueOf(),
          },
        })
      },
      trackDownloadCatalogueClick: () => {
        TroyWebTracker.sendEvent({
          category,
          action: EventAction.clickDownloadcatalogue,
          labels: {
            ...labels,
            TIMESTAMP: new Date().valueOf(),
          },
        })
      },
      trackLearnMoreClick: () => {
        TroyWebTracker.sendEvent({
          category,
          action: EventAction.clickLearnmore,
          labels: {
            ...labels,
            TIMESTAMP: new Date().valueOf(),
          },
        })
      },
    }
  }, [merchantGroupID, merchantID, bulkUploadType, outletV2, menuGroupDetail])
}
